import React from 'react'
import NavBar2 from '../Components/NavBar2';

function PrivacyPolicy() {
  return (
    <div>
        <NavBar2/>
        <div className="container py-5 ">
            
        <h1 className="mb-4 mt-5">Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 1st June 2025</p>
        <p><strong>Last Updated:</strong> 22nd June 2025</p>

        <p>Thank you for using <strong>Kuza Points</strong>, a mobile application and service developed to help businesses turn walk-ins into loyal, repeat customers through an intelligent SMS-based rewards system. At Kuza Points, we value your trust and are committed to protecting your privacy.</p>
        
        <p>This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our app, whether as a business owner, employee, or customer. By using the Kuza Points app, you consent to the data practices described in this policy.</p>

        <h3 className="mt-5">1. Information We Collect</h3>
        <h5>a) Personal Information</h5>
        <ul>
            <li>Full name</li>
            <li>Phone number</li>
            <li>Email address (optional)</li>
            <li>Business details (e.g., name, branch, type)</li>
            <li>Customer phone numbers (input by business for rewards)</li>
            <li>Payment account details (for STK push or withdrawal features)</li>
            <li>Profile information (e.g., profile photo, business logo, branch location)</li>
        </ul>

        <h5>b) Transactional and Loyalty Data</h5>
        <ul>
            <li>Loyalty points awarded and redeemed</li>
            <li>Transaction history (date, time, amount, description)</li>
            <li>Branch and staff data associated with transactions</li>
        </ul>

        <h5>c) Device and App Usage Data</h5>
        <ul>
            <li>Device type and model</li>
            <li>OS version</li>
            <li>IP address</li>
            <li>App usage logs</li>
            <li>Crash logs</li>
        </ul>

        <h5>d) Location Data (Optional)</h5>
        <p>If granted, we may access location data to assign rewards based on branch visits.</p>

        <h3 className="mt-5">2. How We Use Your Information</h3>
        <ul>
            <li>Account management and user authentication</li>
            <li>Rewards and transaction tracking</li>
            <li>SMS communication with customers</li>
            <li>Business analytics for performance insight</li>
            <li>Payment processing via STK Push</li>
            <li>Security monitoring and fraud prevention</li>
            <li>Customer support</li>
        </ul>

        <h3 className="mt-5">3. SMS Functionality</h3>
        <p>We use BongaSMS and Africa’s Talking to:</p>
        <ul>
            <li>Send OTPs</li>
            <li>Notify customers about rewards</li>
            <li>Send promotional messages</li>
            <li>Allow direct SMS engagement by businesses</li>
        </ul>
        <p><strong>Consent:</strong> Businesses are responsible for ensuring that customers have consented to receive SMS notifications.</p>

        <h3 className="mt-5">4. Data Storage and Security</h3>
        <ul>
            <li>Firebase Firestore and Firebase Storage used for secure cloud storage</li>
            <li>Data is encrypted and secured with access rules</li>
            <li>User identity verified via Firebase Authentication</li>
            <li>Role-based access and permission checks enforced</li>
        </ul>

        <h3 className="mt-5">5. Sharing of Information</h3>
        <p>We do not sell your personal data. Data may only be shared with:</p>
        <ul>
            <li>Trusted service providers (e.g., SMS, payment gateways)</li>
            <li>Law enforcement (when legally required)</li>
            <li>Third parties during business acquisitions</li>
        </ul>

        <h3 className="mt-5">6. User Rights</h3>
        <ul>
            <li>Access your personal data</li>
            <li>Correct or delete your information</li>
            <li>Export your data</li>
            <li>Withdraw consent for features like SMS or location</li>
        </ul>
        <p>Contact us at <strong>[insert support email]</strong> to exercise these rights.</p>

        <h3 className="mt-5">7. Data Retention</h3>
        <ul>
            <li>Transaction and business data: retained for 6+ years</li>
            <li>Account data: until deletion</li>
            <li>SMS logs: up to 12 months</li>
            <li>Device diagnostics: up to 6 months</li>
        </ul>

        <h3 className="mt-5">8. Children’s Privacy</h3>
        <p>Kuza Points is not intended for users under the age of 13. We do not knowingly collect information from children.</p>

        <h3 className="mt-5">9. Third-Party Links</h3>
        <p>We are not responsible for the privacy practices of any third-party websites or services linked from our app.</p>

        <h3 className="mt-5">10. Security Practices</h3>
        <ul>
            <li>HTTPS encryption</li>
            <li>Authentication via Firebase</li>
            <li>Strict Firestore security rules</li>
            <li>API key obfuscation and restricted access</li>
        </ul>

        <h3 className="mt-5">11. Changes to This Privacy Policy</h3>
        <p>We may update this policy. You will be notified of significant changes via email or app notification. Continued use indicates acceptance.</p>

        <h3 className="mt-5">12. Contact Us</h3>
        <p>
            <strong>Kuza Points Support Team</strong><br />
            Email: <a href="mailto:support@kuzapoints.com">support@kuzapoints.com</a><br />
            Phone: 0795156925<br />
            Website: <a href="https://www.kuzapoints.com" target="_blank" rel="noopener noreferrer">https://www.kuzapoints.com</a>
        </p>

        <p className="mt-4"><em>By using Kuza Points, you agree to the practices described in this Privacy Policy.</em></p>
        </div>
    </div>
  )
}

export default PrivacyPolicy